import {Link, NavLink, useLocation} from "react-router-dom";
import styled from "styled-components";

const NavContainer = styled.div`

    background-color: var(--content-box-bg);
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    display: flex;

    & > div {
        cursor: pointer;
    }

    & > div > a {
        text-decoration: none;
        color: #e2e2e2;
        padding: 1rem;
        display: block;
        box-shadow: none;
        background-color: transparent;
        transition: background-color 0.3s ease, box-shadow 0.3s ease;
        &:hover {
            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px inset;
            background-color: var(--primary-blue-hover);
        }
        &.active {
            background-color: var(--primary-blue-selected);
            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px inset;
        }
        &.active:hover {
            background-color: var(--primary-blue-selected-hover);
            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px inset;
        }
    }

`;

export default function Navbar() {

    const location = useLocation();

    if (location.pathname.startsWith("/login")) {
        return null; // Don't show the navbar on login page
    }

    return (
        <NavContainer>
            <div><NavLink to="/">Pipelines</NavLink></div>
            <div><NavLink to="/deployments">Deployments</NavLink></div>
            <div><NavLink to="/pipeline-builder">Pipeline-Builder</NavLink></div>
            <div><NavLink to="/simulations">Simulations</NavLink></div>
            <div><NavLink to="/tasks">Tasks</NavLink></div>
            <div><NavLink to="/servers">Servers</NavLink></div>
            <div><NavLink to="/users">Users</NavLink></div>
            <div><NavLink to="/settings">Settings</NavLink></div>
        </NavContainer>
    );
}